// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DownloadPaymentStatusReportRequestModel from '../../model/download-payment-status-report-request-model';
import DownloadPaymentStatusReportRequestDTO from '../dto/download-payment-status-report-request-dto';
import dtoSchema from '../schemas/download-payment-status-report-request-schema';

export default abstract class DownloadPaymentStatusReportRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DownloadPaymentStatusReportRequestDTO>) {
    super();
    if (data) {
      this.redebitIds = data.redebitIds;
    }
  }
  /**
  */
  redebitIds?: number[];

  static toModel(dto: DeepPartial<DownloadPaymentStatusReportRequestDTO>): DownloadPaymentStatusReportRequestModel;
  static toModel(dto: DeepPartial<DownloadPaymentStatusReportRequestDTO> | undefined | null): DownloadPaymentStatusReportRequestModel | undefined;
  static toModel(dto: DeepPartial<DownloadPaymentStatusReportRequestDTO> | undefined | null): DownloadPaymentStatusReportRequestModel | undefined {
    return dto ? new DownloadPaymentStatusReportRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DownloadPaymentStatusReportRequestModel> | DownloadPaymentStatusReportRequestModel): DownloadPaymentStatusReportRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      redebitIds: unwrapped.redebitIds,
    } as DownloadPaymentStatusReportRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DownloadPaymentStatusReportRequestModel, can not map to DownloadPaymentStatusReportRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
